import { z } from "zod";
import {
    searchIntentFiltersSchema,
    searchIntentSchema,
} from "./search-intent.contract.ts";

export const SEARCH_INTENT_OUTPUT_CONTRACT_VERSION = 2 as const;

export const searchInterpretationTargetSchema = z.enum([
    "listings",
    "organizations",
]);

const organizationSearchIntentFiltersSchema = searchIntentFiltersSchema.extend({
    dogName: z.null(),
    breedType: z.null(),
    providerName: z.null().optional(),
    sex: z.null(),
    priceMin: z.null(),
    priceMax: z.null(),
    ageMonthsMin: z.null(),
    ageMonthsMax: z.null(),
    size: z.tuple([]),
    coatType: z.tuple([]),
    sheddingLevel: z.tuple([]),
    hypoallergenic: z.null(),
    friendlinessChildren: z.null(),
    friendlinessDogs: z.null(),
    friendlinessCats: z.null(),
    energyLevel: z.null(),
    trainability: z.null(),
    healthIssuesRisk: z.null(),
    sortBy: z.null(),
});

export const organizationSearchIntentSchema = searchIntentSchema.extend({
    filters: organizationSearchIntentFiltersSchema,
});

export const listingSearchInterpretationSchema = z
    .object({
        target: z.literal("listings"),
        intent: searchIntentSchema,
    })
    .strict();

export const organizationSearchInterpretationSchema = z
    .object({
        target: z.literal("organizations"),
        intent: organizationSearchIntentSchema,
    })
    .strict();

export const searchInterpretationSchema = z.discriminatedUnion("target", [
    listingSearchInterpretationSchema,
    organizationSearchInterpretationSchema,
]);

export const parsedSearchIntentV2Schema = z
    .object({
        intents: z.array(searchInterpretationSchema).min(1).max(3),
    })
    .strict();

export type SearchInterpretationTarget = z.infer<
    typeof searchInterpretationTargetSchema
>;
export type OrganizationSearchIntent = z.infer<
    typeof organizationSearchIntentSchema
>;
export type SearchInterpretation = z.infer<typeof searchInterpretationSchema>;
export type ParsedSearchIntentV2 = z.infer<typeof parsedSearchIntentV2Schema>;
